<section id="sales-settings-container">
    <form [formGroup]="settingsForm">
        <section id='header'>
            <div class='title'>
                <div class='main'>{{ 'servicePersonnel.salesGeneralSettings' | translate }}</div>
            </div>

            <div class='actions'>
                <div class='cancel' (click)="cancel()">{{ 'generalSettings.cancel' | translate }}</div>
                <div class='save-changes' (click)="saveChanges()">
                    <ng-container *ngIf="saveInProgress; else salesSaveLabel">
                        <app-loading loadingSymbol="dots" [text]="'saving' | translate" color="white" size=".7" [compact]="true"></app-loading>
                    </ng-container>
                    <ng-template #salesSaveLabel>{{ 'generalSettings.saveChanges' | translate }}</ng-template>
                </div>
            </div>
        </section>
        <section id='body'>
            <section id="left-content">
                <!-- time-management start -->
                <div id="sales-time-management" class="mat-card settings-card" formGroupName="time">
                    <div class="card-innner-con">
                        <div class="settings-card-title">
                            <div class="operational-message-inline">
                                <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
                                {{ 'generalSettings.anyChangesMadeHereWillNotBeUpdatedInTheDMS' | translate }} <span class="dms" (click)="navigateToDIS()">DIS</span>
                            </div>
                            <div class="title-button">
                                <button (click)=syncDealerDisDetails() class='refresh' type="button"
                                  [title]="getIntegrationText()" 
                                  [disabled]="syncInProgress"
                                  [ngClass]="syncInProgress ? 'disabled': ''">
                                                                    <ng-container *ngIf="syncInProgress; else salesSettingsSyncLabel">
                                                                        <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".55" [compact]="true"></app-loading>
                                                                    </ng-container>
                                                                    <ng-template #salesSettingsSyncLabel>
                                                                        <asp-icon class="icon d-inline-block" name="ic-20-utility-update-small.svg" width="1.2rem"
                                                                            height='1.2rem' color='var(--primary-toyota-color)'>
                                                                        </asp-icon>
                                                                        <span>{{ getIntegrationText() | translate }}</span>
                                                                    </ng-template>
                                </button>
                            </div>
                        </div>
                        <div class="settings-card-body">
                            <div class="time-management-overview">
                                <div class="operational-container">
                                    <div class="operational-title">
                                        <span>{{ 'generalSettings.operationalHours' | translate}}</span>
                                    </div>
                                    <div class="operational-body">
                                        <div class="field-container" *ngFor="let obj of hoursOfOperation">
                                            <div class="field-title">
                                                <span>{{getTranslation(obj.day)}}</span>
                                            </div>
                                            <div class="field-value">
                                                <span class="optional-list-sub" [ngClass]="{'no-word-spacing' : obj.operation === 'Data not found in DIS'}">{{obj.operation === 'Closed' ? ('serviceSchedule.closed' | translate) :
                                                    obj.operation === 'Data not found in DIS' ? ('serviceSchedule.closedConfirm' | translate) : obj.operation}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="time-management-splitter" aria-hidden="true"></div>

                                <div class="amenities-container">
                                    <div class="amenities-header-row">
                                        <div class="operational-title">
                                            <span>{{ 'generalSettings.amenities' | translate }}</span>
                                        </div>
                                        <div class="field-value custom-switch">
                                            <app-onofswitch [switchInput]='portalSwitches.enableAmenities'
                                                (switchChange)="updateSwitchValues($event, 'enableAmenities')"></app-onofswitch>
                                            <div class="readonly-layer" *ngIf="!hasAmenities"></div>
                                        </div>
                                    </div>
                                    <div class="amenities-body">
                                        <ng-container *ngIf="hasAmenities; else salesNoAmenitiesState">
                                            <ul class="amenities-list">
                                                <li *ngFor="let value of amenities">{{ value }}</li>
                                            </ul>
                                        </ng-container>
                                        <ng-template #salesNoAmenitiesState>
                                            <div class="no-amenities-message">{{ 'generalSettings.noAmenitiesInDIS' | translate }}</div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>

                            <div class="field-container time-settings-row">
                                <div class="field-input">
                                    <label>{{ 'generalSettings.timeSlotDuration' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="slotDuration">
                                            <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="field-input">
                                    <label>{{ 'generalSettings.onlineAppointmentCut-offTime' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="cutOffTime">
                                            <mat-option [value]='obj.value' *ngFor="let obj of curOffTime">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-container mt25">
                                <div class="field-input">
                                    <label>{{ 'generalSettings.timezone'| translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="timeZone">
                                            <mat-option [value]='obj.value' *ngFor="let obj of ((timezones$ | async) | alphabetize:'label')">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>{{'generalSettings.timezoneIsrequired' | translate }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-container mt25">
                                <div class="time-management-input">
                                    <div class="field-title">
                                        {{ 'searchCustomer.vehicleInquiry' | translate}}
                                    </div>
                                    <label>{{'generalSettings.appointmentDuration' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="vehicleInquiryDuration">
                                            <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="time-management-input">
                                    <div class="field-title">
                                        {{ 'searchCustomer.testDrive' | translate}}
                                    </div>
                                    <label>{{'generalSettings.appointmentDuration' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="testdriveAppointmentDuration">
                                            <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="time-management-input" *ngIf="showDelivery">
                                    <div class="field-title">
                                       {{ 'generalSettings.contracting' | translate}}
                                    </div>
                                    <label>{{'generalSettings.appointmentDuration' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="deliveryAppointmentDuration">
                                            <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="time-management-input">
                                    <div class="field-title">
                                        {{ 'searchCustomer.techcenter' | translate}}
                                    </div>
                                    <label>{{'generalSettings.appointmentDuration' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="techcenterAppointmentDuration">
                                            <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="time-management-input">
                                    <div class="field-title">
                                        {{ 'delivery.delivery' | translate}}
                                    </div>
                                    <label>{{'generalSettings.appointmentDuration' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="deliveryApptDuration">
                                            <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                                                {{ obj.label }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- time-management end -->

                <app-switch-card [title]="'generalSettings.alexaBooking' | translate" [value]="alexaEnabled" [tooltip]="tooltip.alexa" [label]="'generalSettings.enableAlexaBooking' | translate" (switchValueChange)="updateSwitchValues($event, 'alexaEnabled')" *ngIf = "false">
                </app-switch-card>

                 <!-- online-portal-settings start -->
                 <div id="sales-online-portal-settings" class="mat-card settings-card" formGroupName="portal" #portalcon>   
                    <div class="card-innner-con">
                        <div class="settings-card-title pb-3" >
                            <span>{{ 'generalSettings.onlinePortalSettings' | translate}}</span>
                            <span class="material-icons" [matTooltip]="tooltip.portal"
                            matTooltipClass="asp-custom-tooltip">help_outline </span>
                        </div>
                        <div class="settings-card-body">
                            <div class="field-container ">
                                <div class="field-title">
                                    {{ 'searchCustomer.testDrive' | translate}}
                                </div>
                                <div class="settings-spacer"></div>
                                <div class="field-title">
                                    {{ 'generalSettings.available' | translate}}
                                </div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='portalSwitches.enableTestDrive'
                                        (switchChange)="updateSwitchValues($event, 'enableTestDrive')"></app-onofswitch>
                                </div>
                            </div>   
                            <div class="field-container ">
                                <div class="settings-spacer"></div>
                                <div class="field-title">
                                    {{ 'generalSettings.hideSalesConsultant' | translate}}
                                </div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='portalSwitches.hideSalesConsultant'
                                        (switchChange)="updateSwitchValues($event, 'hideSalesConsultant')">
                                    </app-onofswitch>
                                </div>
                            </div>                       
                            <div class="field-container pb-3">
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerTitleText' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <input matInput placeholder="{{'generalSettings.enterTestDriveBannerTitleText' | translate }}"
                                            formControlName="testDriveBannerTitleText" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerBodyText' | translate }}</label>
                                    <mat-form-field class="no-fixed-height" appearance="outline">
                                        <textarea matInput placeholder="{{'generalSettings.enterTestDriveBannerBodyText' | translate }}"
                                            formControlName="testDriveBannerBodyText">
                                        </textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                          
                                <div class="field-container">
                                    <div class="field-title">
                                        {{ 'generalSettings.delivery' | translate}}
                                    </div>
                                    <div class="settings-spacer"></div>
                                    <div class="field-title">
                                        {{ 'generalSettings.available' | translate}}
                                    </div>
                                    <div class="field-value custom-switch">
                                        <app-onofswitch [switchInput]='portalSwitches.enableDelivery'
                                            (switchChange)="updateSwitchValues($event, 'enableDelivery')"></app-onofswitch>
                                        </div>
                                </div>
                                <div class="field-container ">
                                    <div class="settings-spacer"></div>
                                    <div class="field-title">
                                        {{ 'generalSettings.lockSalesConsultant' | translate}}
                                    </div>
                                    <div class="field-value custom-switch">
                                        <app-onofswitch [switchInput]='portalSwitches.lockSalesConsultant === "Lock" ? true : false'
                                            (switchChange)="updateSwitchValues($event, 'lockSalesConsultant')"></app-onofswitch>
                                        </div>
                                </div>                  
                                <div class="field-container pb-3" *ngIf="showDelivery">
                                <div class="field-input delivery-buffer-days-field">
                                    <div class="field-label-with-icon">
                                        <label>{{'generalSettings.deliveryBufferDays' | translate }}</label>
                                        <button
                                            mat-icon-button
                                            type="button"
                                            class="delivery-buffer-days-info-btn"
                                            [matTooltip]="tooltip.deliveryBufferDays"
                                            matTooltipClass="asp-custom-tooltip"
                                            matTooltipPosition="above"
                                            #deliveryBufferDaysTooltip="matTooltip"
                                            [attr.aria-label]="'generalSettings.deliveryBufferDays' | translate"
                                            (mouseenter)="deliveryBufferDaysTooltip.show()"
                                            (mouseleave)="deliveryBufferDaysTooltip.hide()"
                                            (focus)="deliveryBufferDaysTooltip.show()"
                                            (blur)="deliveryBufferDaysTooltip.hide()"
                                            (keydown.enter)="deliveryBufferDaysTooltip.show()"
                                            (keydown.space)="deliveryBufferDaysTooltip.show(); $event.preventDefault()">
                                            <mat-icon>info_outline</mat-icon>
                                        </button>
                                    </div>
                                    <mat-form-field appearance="outline">
                                        <input
                                            matInput
                                            placeholder="{{'generalSettings.chooseUpTo99BufferDays' | translate }}"
                                            formControlName="deliveryBufferDays"
                                            type="text"
                                            inputmode="numeric"
                                            maxlength="2"
                                            autocomplete="off"
                                            (input)="onDeliveryBufferDaysInput()">
                                    </mat-form-field>
                                </div>
                                <div class="field-input"></div>
                            </div>
                                <div class="field-container" *ngIf="showDelivery">
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerTitleText' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <input matInput placeholder="{{'generalSettings.enterDeliveryBannerTitleText' | translate }}"
                                            formControlName="deliveryBannerTitleText" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerBodyText' | translate }}</label>
                                    <mat-form-field class="no-fixed-height" appearance="outline">
                                        <textarea matInput placeholder="{{'generalSettings.enterDeliveryBannerBodyText' | translate }}"
                                            formControlName="deliveryBannerBodyText">
                                        </textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            
                            <div class="d-flex flex-column pb-3" *ngIf="showDelivery">
                                <mat-accordion>
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>{{'generalSettings.pDIChecklist' | translate }}</mat-panel-title>
                                          </mat-expansion-panel-header>
                                        <div *ngIf="!(pdiChecklist.controls.length > 0)" class="font-size-0-8 mb-1"><span>{{'generalSettings.theChecklistIsEmpty' | translate }}</span></div>
                                        <ng-container formArrayName="pdiChecklist">
                                            <div class="settings-card-body trans-card d-flex" *ngFor="let checklist of pdiChecklist.controls; let i = index">
                                                <mat-form-field appearance="outline" class="trans-comment">
                                                    <input matInput maxlength="128" [formControlName]="i">
                                                    <mat-error>
                                                        {{'generalSettings.pleaseEnterValidData' | translate }}
                                                    </mat-error>
                                                </mat-form-field>
                                                <button class="btn asp-btn-secondary asp-btn-height my-auto" (click)="removeChecklistItem(i)">
                                                    <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color='rgba(14,19,25,0.8)'></asp-icon>
                                                </button>
                                            </div>
                                        </ng-container>
                                        <button class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2" (click)=addChecklistItem()>{{'generalSettings.addnew' | translate }}</button>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                            <div class="field-container">
                                <div class="field-title">
                                    {{ 'searchCustomer.techcenter' | translate}}
                                </div>
                                <div class="settings-spacer"></div>
                                <div class="field-title">
                                    {{ 'generalSettings.available' | translate}}
                                </div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='portalSwitches.enableLearning'
                                        (switchChange)="updateSwitchValues($event, 'enableLearning')"></app-onofswitch>
                                </div>
                            </div>   
                            <div class="field-container pb-3">
                               
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerTitleText' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <input matInput placeholder="{{'generalSettings.enterTechCenterBannerTitleText' | translate }}"
                                            formControlName="techCenterBannerTitleText" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerBodyText' | translate }}</label>
                                    <mat-form-field class="no-fixed-height" appearance="outline">
                                        <textarea matInput placeholder="{{'generalSettings.enterTechCenterBannerBodyText' | translate }}"
                                            formControlName="techCenterBannerBodyText">
                                        </textarea>
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- Vehicle Inquiry Block -->
                            <div class="field-container">
                                <div class="field-title">
                                    {{ 'generalSettings.vehicleInquiry' | translate}}
                                </div>
                                <div class="settings-spacer"></div>
                                <div class="field-title">
                                    {{ 'generalSettings.available' | translate}}
                                </div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='portalSwitches.enableVehicleInquiry'
                                        (switchChange)="updateSwitchValues($event, 'enableVehicleInquiry')"></app-onofswitch>
                                </div>
                            </div>   
                            <div class="field-container pb-3">
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerTitleText' | translate }}</label>
                                    <mat-form-field appearance="outline">
                                        <input matInput placeholder="{{'generalSettings.enterVehicleInquiryBannerTitleText' | translate }}"
                                            formControlName="vehicleInquiryBannerTitleText" type="text">
                                    </mat-form-field>
                                </div>
                                <div class="field-input">
                                    <label>{{'generalSettings.bannerBodyText' | translate }}</label>
                                    <mat-form-field class="no-fixed-height" appearance="outline">
                                        <textarea matInput placeholder="{{'generalSettings.enterVehicleInquiryBannerBodyText' | translate }}"
                                            formControlName="vehicleInquiryBannerBodyText">
                                        </textarea>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="field-container ">
                                <div class="settings-spacer"></div>
                                <div class="field-title">
                                    {{ 'generalSettings.enableTradeIn' | translate}}
                                </div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='portalSwitches.enableTradeIn'
                                        (switchChange)="updateSwitchValues($event, 'enableTradeIn')">
                                    </app-onofswitch>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- online-portal-settings end -->
            </section>
            <section id="right-content">

                <!-- Transport Management start -->
                <div id="sales-transport-management" class="mat-card settings-card" formGroupName="transport">
                    <div class="card-innner-con">
                        <div class="settings-card-title">
                            <span>{{'generalSettings.remoteAppointmentManagement' | translate }}</span>
                            <span class="material-icons" [matTooltip]="tooltip.transport"
                            matTooltipClass="asp-custom-tooltip">help_outline </span>
                        </div>
                        <ng-container formArrayName="transportOptions">
                            <div class="settings-card-body trans-card"
                                *ngFor="let transOptions of transportOptions.controls; let i = index" [formGroupName]="i">
                                <div class="d-flex"><mat-checkbox class="trans-check" value="transOptions" 
                                formControlName="isActive" *ngIf="(transOptions.value.id!== 'DEALER')"
                                (change)="setZipcodeValidation(transOptions.value, $event);" 
                                disableRipple>{{getTranslation(transOptions.value.label)}}
                                </mat-checkbox>
                                <mat-form-field appearance="outline" class="trans-comment" *ngIf="(transOptions.value.id!== 'DEALER')">
                                    <input matInput placeholder="{{'generalSettings.comments' | translate }}" formControlName="comments">
                                </mat-form-field>
                                </div>
                                <div class="d-flex trans-app-type" *ngIf="(transOptions.value.id!== 'DEALER')">
                                    <mat-checkbox class="trans-check" 
                                        formControlName="enableTestDriveType" [disabled]="!transOptions.value.isActive">
                                        <span>{{ 'searchCustomer.testDrive' | translate}}</span>
                                    </mat-checkbox>
                                    <mat-checkbox class="trans-check" 
                                        formControlName="enableDeliveryType" [disabled]="!transOptions.value.isActive">
                                        <span>{{ 'generalSettings.delivery' | translate}}</span>
                                    </mat-checkbox>
                                    <mat-checkbox class="trans-check"  
                                        formControlName="enableLearningType" [disabled]="true">
                                        <span>{{ 'searchCustomer.techcenter' | translate}} {{'searchCustomer.comingSoon' | translate}}</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </ng-container>
                        <div class="trans-card d-flex" *ngIf="isUsDealer">
                            <div class="trans-check">{{'generalSettings.includeRemoteZipCode' | translate }}</div>
                            <mat-form-field appearance="outline">
                                <mat-select multiple disableRipple placeholder="{{'generalSettings.select' | translate}}"
                                    formControlName="includedRemoteZipCodes">
                                    <mat-option *ngFor="let zipcode of zipcodes$ | async" [value]="zipcode">{{zipcode}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{'generalSettings.remoteZipCodeIsRequired' | translate }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <!-- Transport Management end -->
                
                <div id="sales-reminder-email-settings" class="mat-card settings-card" #remindermailcon>
                    <div class="card-innner-con">
                      <div class="settings-card-title">
                        <span>{{ 'generalSettings.customerNotification' | translate}}</span>
                        <span class="material-icons" [matTooltip]="tooltip.customerNotification"
                          matTooltipClass="asp-custom-tooltip">help_outline </span>
                      </div>
                      <div id="sales-email-section" class="settings-card-body">
                        <div class="field-container">
                          <div class="filed-title">
                            <span>{{ 'generalSettings.enableCustomerNotification' | translate }}</span>
                          </div>
                          <div class="settings-spacer"></div>
                          <div class="filed-value custom-switch">
                            <app-onofswitch [switchInput]='customerNotificationEnabled'
                              (switchChange)="updateSwitchValues($event, 'customerNotificationEnabled')"></app-onofswitch>
                          </div>
                        </div>
                        <div class="field-container">
                          <div class="filed-title">
                            <span>{{ 'generalSettings.reminderNotification' | translate }}</span>
                          </div>
                          <div class="settings-spacer"></div>
                          <div class="filed-value custom-switch"  [ngStyle]="{'pointer-events': settingsForm.controls['customerNotificationEnabled'].value ? '' : 'none'}">
                            <app-onofswitch [switchInput]='reminderNotificationEnabled'
                              (switchChange)="updateSwitchValues($event, 'reminderNotificationEnabled')"></app-onofswitch>
                          </div>
                        </div>
                        <div class="trans-card">
                          <div class="trans-check">{{'generalSettings.selectReminderSchedule' | translate }}</div>
                          <mat-form-field appearance="outline">
                            <mat-select multiple disableRipple placeholder="{{'generalSettings.select' | translate}}" formControlName="reminderNotificationSchedule">
                              <mat-option *ngFor="let scheduleVal of scheduleValues" [value]="scheduleVal">{{scheduleVal}}
                              </mat-option>
                            </mat-select>
                            <mat-error>{{'generalSettings.reminderScheduleIsRequired' | translate }}</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>

                <!-- Alert Notification Settings start -->
                    <div id="sales-alert-settings" class="mat-card settings-card">
                        <div class="card-innner-con">
                            <div class="settings-card-title">
                                <span>{{'generalSettings.alertNotificationSettings' | translate }}</span>
                                <span class="material-icons" [matTooltip]="tooltip.notifications"
                                matTooltipClass="asp-custom-tooltip">help_outline </span>
                            </div>
                            <div class="settings-card-body">
                                <div class="field-container">
                                    <div class="field-title">
                                        <span>{{'generalSettings.failedNotifications' | translate }}</span>
                                    </div>
                                    <div class="settings-spacer"></div>
                                    <div class="field-value custom-switch">
                                        <app-onofswitch [switchInput]='isEnable("syncFailure")' (switchChange)="updateSwitchValues($event, 'syncFailure')"></app-onofswitch>
                                        <div class="readonly-layer"></div>
                                    </div>
                                </div>
    
                                <div class="d-flex flex-column">
                                    <mat-accordion>
                                        <mat-expansion-panel formGroupName="notification">
                                          <mat-expansion-panel-header>
                                            <mat-panel-title>{{'generalSettings.emailAddress' | translate }}</mat-panel-title>
                                          </mat-expansion-panel-header>
                                          
                                          <ng-container formGroupName="syncFailure">
                                            <ng-container formArrayName="distributionList">
                                                <div *ngIf="!(distributionList('syncFailure').length > 0)" class="font-size-0-8 mb-1"><span>{{'generalSettings.distributionListIsEmpty' | translate }}</span></div>
                                                <div class="settings-card-body trans-card d-flex" *ngFor="let checklist of distributionList('syncFailure').controls; let i = index">
                                                    <mat-form-field appearance="outline" class="trans-comment">
                                                        <input matInput maxlength="128" [formControlName]="i" autocomplete="off">
                                                        <mat-error>{{ 'generalSettings.pleaseEnterValidEmail' | translate }}</mat-error>
                                                    </mat-form-field>
                                                    <button class="btn asp-btn-secondary asp-btn-height my-auto" (click)="removeDistributionList('syncFailure', i)">
                                                        <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color='rgba(14,19,25,0.8)'></asp-icon>
                                                    </button>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <button class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2" (click)="addDistributionList('syncFailure')">{{ 'generalSettings.addnew' | translate }}</button>
        
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                                
                                
                                <div class="field-container" *ngIf="false">
                                    <div class="field-title">
                                        <span>{{ 'generalSettings.notificationForCustomerSlotRequest' | translate }}</span>
                                    </div>
                                    <div class="settings-spacer"></div>
                                    <div class="field-value custom-switch">
                                        <app-onofswitch [switchInput]='isEnable("customerSlot")'
                                            (switchChange)="updateSwitchValues($event, 'customerSlot')"></app-onofswitch>
                                    </div>
                                </div>
    
                                <div class="field-container">
                                    <div class="field-title">
                                        <span>{{'generalSettings.appointmentNotifications' | translate }}</span>
                                    </div>
                                    <div class="settings-spacer"></div>
                                    <div class="field-value custom-switch">
                                        <app-onofswitch [switchInput]='isEnable("appointment")'
                                            (switchChange)="updateSwitchValues($event, 'appointment')"></app-onofswitch>
                                    </div>
                                </div>
    
                                <div class="d-flex flex-column">
                                    <mat-accordion>
                                        <mat-expansion-panel formGroupName="notification">
                                          <mat-expansion-panel-header>
                                            <mat-panel-title>{{'generalSettings.emailAddress' | translate }}</mat-panel-title>
                                          </mat-expansion-panel-header>
        
                                          <ng-container formGroupName="appointment">
                                                <ng-container formArrayName="distributionList">
                                                    <div *ngIf="!(distributionList('appointment').length > 0)" class="font-size-0-8 mb-1"><span>{{'generalSettings.distributionListIsEmpty' | translate }}</span></div>
                                                    <div class="settings-card-body trans-card d-flex" *ngFor="let checklist of distributionList('appointment').controls; let i = index">
                                                        <mat-form-field appearance="outline" class="trans-comment">
                                                            <input matInput maxlength="128" [formControlName]="i" autocomplete="off">
                                                            <mat-error>{{ 'generalSettings.pleaseEnterValidEmail' | translate }}</mat-error>
                                                        </mat-form-field>
                                                        <button class="btn asp-btn-secondary asp-btn-height my-auto" (click)="removeDistributionList('appointment', i)">
                                                            <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color='rgba(14,19,25,0.8)'></asp-icon>
                                                        </button>
                                                    </div>
                                                </ng-container>
                                          </ng-container>
                                          <button class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2" (click)="addDistributionList('appointment')">{{'generalSettings.addnew' | translate }}</button>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                            <div class="field-container">
                                <div class="field-title">
                                    <span>{{'generalSettings.vehicleStatusNotification(deliveryAppointments)' | translate}}</span>
                                </div>
                                <div class="settings-spacer"></div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='isEnable("delivery")'
                                        (switchChange)="updateSwitchValues($event, 'delivery')"></app-onofswitch>
                                </div>
                            </div>

                            <div class="d-flex flex-column">
                                <mat-accordion>
                                    <mat-expansion-panel formGroupName="notification">
                                      <mat-expansion-panel-header>
                                        <mat-panel-title>{{'generalSettings.emailAddress' | translate }}</mat-panel-title>
                                      </mat-expansion-panel-header>
    
                                      <ng-container formGroupName="delivery">
                                            <ng-container formArrayName="distributionList">
                                                <div *ngIf="!(distributionList('delivery').length > 0)" class="font-size-0-8 mb-1"><span>{{'generalSettings.distributionListIsEmpty' | translate }}</span></div>
                                                <div class="settings-card-body trans-card d-flex" *ngFor="let checklist of distributionList('delivery').controls; let i = index">
                                                    <mat-form-field appearance="outline" class="trans-comment">
                                                        <input matInput maxlength="128" [formControlName]="i" autocomplete="off">
                                                        <mat-error>{{ 'generalSettings.pleaseEnterValidEmail' | translate }}</mat-error>
                                                    </mat-form-field>
                                                    <button class="btn asp-btn-secondary asp-btn-height my-auto" (click)="removeDistributionList('delivery', i)">
                                                        <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color='rgba(14,19,25,0.8)'></asp-icon>
                                                    </button>
                                                </div>
                                            </ng-container>
                                      </ng-container>
                                      <button class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2" (click)="addDistributionList('delivery')">{{'generalSettings.addnew' | translate }}</button>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                            <div class="field-container">
                                <div class="field-title">
                                    <span>{{'generalSettings.vehicleStatusNotification(testDriveAppointments)' | translate}}</span>
                                </div>
                                <div class="settings-spacer"></div>
                                <div class="field-value custom-switch">
                                    <app-onofswitch [switchInput]='isEnable("testDrive")'
                                        (switchChange)="updateSwitchValues($event, 'testDrive')"></app-onofswitch>
                                </div>
                            </div>

                            <div class="d-flex flex-column">
                                <mat-accordion>
                                    <mat-expansion-panel formGroupName="notification">
                                      <mat-expansion-panel-header>
                                        <mat-panel-title>{{'generalSettings.emailAddress' | translate }}</mat-panel-title>
                                      </mat-expansion-panel-header>
    
                                      <ng-container formGroupName="testDrive">
                                            <ng-container formArrayName="distributionList">
                                                <div *ngIf="!(distributionList('testDrive').length > 0)" class="font-size-0-8 mb-1"><span>{{'generalSettings.distributionListIsEmpty' | translate }}</span></div>
                                                <div class="settings-card-body trans-card d-flex" *ngFor="let checklist of distributionList('testDrive').controls; let i = index">
                                                    <mat-form-field appearance="outline" class="trans-comment">
                                                        <input matInput maxlength="128" [formControlName]="i" autocomplete="off">
                                                        <mat-error>{{ 'generalSettings.pleaseEnterValidEmail' | translate }}</mat-error>
                                                    </mat-form-field>
                                                    <button class="btn asp-btn-secondary asp-btn-height my-auto" (click)="removeDistributionList('testDrive', i)">
                                                        <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color='rgba(14,19,25,0.8)'></asp-icon>
                                                    </button>
                                                </div>
                                            </ng-container>
                                      </ng-container>
                                      <button class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2" (click)="addDistributionList('testDrive')">{{'generalSettings.addnew' | translate }}</button>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- Alert Notification Settings end -->
        <!-- Capacity Management start-->
        <div id="capacity-management-settings" class="mat-card settings-card" formGroupName="capacity" #capacity>
            <div class="card-innner-con">
              <div class="settings-card-title">
                <span>{{'generalSettings.capacityManagement' |translate }}</span>
                <span class="material-icons" [matTooltip]="tooltip.capacity"
                  matTooltipClass="asp-custom-tooltip">help_outline </span>
              </div>
              <div class="settings-card-body">
                <div class="field-container">
                  <span class="sub-heading">{{'generalSettings.quickSlotCapacitySetup' |translate }}</span>
                </div>
                <div class="field-container">
                  <div class="field-input" style="width: 100%;">
                    <label> {{'generalSettings.dailyAverageSalesSlots' |translate }}</label>
                    <mat-form-field appearance="outline">
                      <input matInput placeholder="{{'generalSettings.enterAverageSalesSlots' |translate }}" formControlName="dailyAverageServiceSlots" type="number"
                        min="1" required>
                      <mat-error>
                        {{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0' |translate }}</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="field-container">
                  <span class="margin-allignment">{{'generalSettings.slotCapacityCalculationMethod' |translate }}</span>
                </div>
                <div class="field-container">
                    <div class="selection-container">
                      <div class="item" [ngClass]="{'selected' : slotsCalculationMethod === 'DAS' }"
                      [ngStyle]="{'padding': !isEnglishText ? '20px 10px' : '10px 10px' }" (click)="onSlotCapacityMethodChange('DAS')">
                          <span >{{'generalSettings.dailyAverageSlots' |translate }} ({{dailyAverageServiceSlots}})</span>
                      </div>
                      <div class="item" [ngClass]="{'selected' : slotsCalculationMethod === 'DCS'}"  (click)="onSlotCapacityMethodChange('DCS')">
                        <span style="text-align: center">{{'generalSettings.advancedSlotCapacitySetup' |translate }} ({{detailedCapcitySetup}})</span>
                      </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
          <!-- Capacity Management end-->
            </section>
        </section>
    </form>
</section>
